import { Component, Inject } from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogRef,
	MatDialogClose,
	MatDialogActions,
} from '@angular/material/dialog';
import { UntypedFormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatRipple } from '@angular/material/core';
import { MatFormField, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

import { AuTechnoBtnComponent } from '../../../shared/ui-components/au-techno-btn/au-techno-btn.component';
import { NgxTolgeeModule } from '@tolgee/ngx';

export interface ChangeFloorNameData {
	currentFloorName: string;
}

@Component({
	templateUrl: './change-floor-name.component.html',
	imports: [
		MatIcon,
		MatDialogClose,
		MatRipple,
		MatFormField,
		MatInput,
		ReactiveFormsModule,
		MatError,
		MatDialogActions,
		AuTechnoBtnComponent,
		NgxTolgeeModule,
	],
})
export class ChangeFloorNameComponent {
	control: UntypedFormControl;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: ChangeFloorNameData,
		private dialogRef: MatDialogRef<ChangeFloorNameComponent>
	) {
		this.control = new UntypedFormControl(
			data.currentFloorName,
			Validators.compose([Validators.required])
		);
	}

	renameApproved() {
		this.dialogRef.close(this.control.value);
	}
}
